import React from 'react';
import PostJob from '../PostJob';
import BusinessLayout from '../../components/BusinessLayout';

const PostJobWithLayout: React.FC = () => {
  return (
    <BusinessLayout>
      <div className="p-6">
        <PostJob />
      </div>
    </BusinessLayout>
  );
};

export default PostJobWithLayout;
